import {ReactElement} from 'react';
import {Image} from '@shopify/hydrogen';

interface ImageContainerProps {
  jpegSrc: string;
  webpSrc?: string;
  widthInPx?: number;
  heightInPx?: number;
  alt?: string;
}

export default function ImageContainer({
  jpegSrc,
  webpSrc,
  widthInPx = 800,
  heightInPx = 800,
  alt = 'Image',
}: ImageContainerProps): ReactElement {
  return (
    <picture>
      {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
      <source srcSet={jpegSrc} type="image/jpeg" />
      <Image src={jpegSrc} width={widthInPx} height={heightInPx} alt={alt} />
    </picture>
  );
}
